import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { completeMcpOauth } from '@/API/repositories/mcp';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { getMcpRedirectHost } from '../helpers/getMcpRedirectHost';
import { returnToMcpClient } from '../helpers/returnToMcpClient';

const useMcpConsent = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [redirectUrl, setRedirectUrl] = useState('');

	const mcpRequest = searchParams.get('mcp_request') || '';
	const redirectHost = getMcpRedirectHost(
		searchParams.get('redirect_uri') || '',
	);
	const isConnecting = hasUnfilledRequest(completeMcpOauth);

	const handleConnect = async () => {
		if (!mcpRequest || isConnecting || redirectUrl) {
			return;
		}

		const response = await makeRequest(completeMcpOauth.bind(null, mcpRequest));
		const nextUrl = response.data?.redirect_url;

		if (!nextUrl) {
			addMessage(response.message || 'Error :(', 'error');
			return;
		}

		setRedirectUrl(nextUrl);
		returnToMcpClient(nextUrl);
	};

	const handleCancel = () => {
		navigate('/');
	};

	return {
		redirectHost,
		redirectUrl,
		isConnecting,
		handleConnect,
		handleCancel,
	};
};

export default useMcpConsent;
